import React from 'react';
import data from './data';
import './index.css';

const CountryIcon = ({ iso }: { iso?: string | null }) => {
  // let sizeClass;
  // switch (size) {
  //   case 'small':
  //     sizeClass = 'small';
  //     break;
  //   case 'medium':
  //     sizeClass = 'medium';
  //     break;
  //   default:
  //     sizeClass = 'small';
  // }
  const country = data.find(c => c.code === iso);
  return country ? (
  <span>{country.emoji}</span>
  ) : null;
};

export default CountryIcon;
